
import React from 'react';
import { TerraceSubmission } from '@/types/terrace';
import SubmissionCard from './SubmissionCard';

interface SubmissionsListProps {
  submissions: TerraceSubmission[];
}

const SubmissionsList = ({ submissions }: SubmissionsListProps) => {
  return (
    <div className="grid gap-4">
      {submissions.map((submission) => (
        <SubmissionCard key={submission.id} submission={submission} />
      ))}
    </div>
  );
};

export default SubmissionsList;
